window.addEventListener('DOMContentLoaded', (event) => {
  const isReduced =
    window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

  // const isReduced = true;

  if (isReduced) {
    const autoplayVideos = document.querySelectorAll('video[autoplay]');

    for (let i = 0; i < autoplayVideos.length; i++) {
      const video = autoplayVideos[i];

      video.pause();
    }
  }
});
